(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 7265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin",
      function () {
        return __webpack_require__(5856);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_icons_cg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(471);







var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "block" : _className, _color = _param.color, color = _color === void 0 ? "main" : _color, children = _param.children, disabled = _param.disabled, loading = _param.loading, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "color",
        "children",
        "disabled",
        "loading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative flex select-none items-center rounded p-3.5 px-5 text-sm font-bold uppercase text-white transition-[padding] duration-300 active:brightness-90", {
            "bg-conversion hover:bg-conversionHover": color == "main",
            "bg-red-500 hover:bg-red-600": color == "red",
            "pointer-events-none pr-12": loading,
            "bg-conversionHover brightness-90": loading && color == "main",
            "bg-red-500 brightness-90": loading && color == "red",
            "pointer-events-none bg-conversionHover brightness-[0.7]": disabled
        }, className),
        ref: ref
    }, rest), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_cg__WEBPACK_IMPORTED_MODULE_6__/* .CgSpinner */ .frZ, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute right-4 animate-spin text-body transition-[opacity] duration-300", {
                    "opacity-100": loading,
                    "opacity-0": !loading
                }),
                size: 22
            })
        ]
    }));
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9583);





var Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "block" : _className, name = _param.name, tmp = _param.type, defaultType = tmp === void 0 ? "text" : tmp, label = _param.label, error = _param.error, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "name",
        "type",
        "label",
        "error"
    ]);
    var id = (0,react__WEBPACK_IMPORTED_MODULE_1__.useId)();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultType), type = _$ref[0], setType = _$ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                        id: id,
                        name: name,
                        type: type,
                        ref: ref,
                        className: "peer mr-4 h-full w-full rounded border-2 border-darker bg-darker p-2 px-3 outline-none",
                        placeholder: ""
                    }, rest)),
                    defaultType == "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute right-0 top-0 flex h-full cursor-pointer items-center p-3 text-xl text-placeholder hover:text-body",
                        onClick: function() {
                            return setType(type == "text" ? "password" : "text");
                        },
                        children: [
                            type == "text" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaRegEyeSlash */ .tjB, {}),
                            type == "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaRegEye */ .z5B, {})
                        ]
                    }),
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: id,
                        className: "before:content[' '] after:content[' '] before:border-blue-gray-200 after:border-blue-gray-200 peer-placeholder-shown:text-blue-gray-500 peer-disabled:peer-placeholder-shown:text-blue-gray-500 pointer-events-none absolute -top-1.5 left-0 flex h-full w-full select-none text-[13px] font-normal leading-[0.75] text-placeholder transition-all before:pointer-events-none before:mr-1 before:mt-[6.5px] before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:transition-all after:pointer-events-none after:ml-1 after:mt-[6.5px] after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:transition-all peer-placeholder-shown:text-base peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[13px] peer-focus:leading-[0.75] peer-focus:text-conversionText peer-disabled:text-transparent",
                        children: label
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-4 text-sm text-red-500",
                children: error
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 5856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SignIn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4685);
/* harmony import */ var _components_ui_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(381);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);










function SignIn() {
    var status = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.useSession)().status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), formStatus = ref[0], setFormStatus = ref[1];
    var usernameRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var passwordRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    if (status == "authenticated") {
        router.push("/");
    }
    function login() {
        return _login.apply(this, arguments);
    }
    function _login() {
        _login = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = usernameRef.current) === null || ref === void 0 ? void 0 : ref.value) || lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()((ref1 = usernameRef.current) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                            return [
                                2
                            ];
                        }
                        if (!((ref2 = passwordRef.current) === null || ref2 === void 0 ? void 0 : ref2.value) || lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()((ref3 = passwordRef.current) === null || ref3 === void 0 ? void 0 : ref3.value)) {
                            return [
                                2
                            ];
                        }
                        setFormStatus("loading");
                        return [
                            4,
                            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.signIn)("credentials", {
                                username: (ref4 = usernameRef.current) === null || ref4 === void 0 ? void 0 : ref4.value,
                                password: (ref5 = passwordRef.current) === null || ref5 === void 0 ? void 0 : ref5.value,
                                redirect: false
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (!(data === null || data === void 0 ? void 0 : data.ok)) {
                            setFormStatus("error");
                            return [
                                2
                            ];
                        }
                        setFormStatus("success");
                        return [
                            2
                        ];
                }
            });
        });
        return _login.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mx-auto max-w-sm pt-32",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "mb-6 text-2xl font-bold sm:mb-8 sm:text-3xl",
                    children: "Login"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ref: usernameRef,
                    label: "Username",
                    className: "mb-5 w-[300px]",
                    onKeyDown: function(e) {
                        return e.key == "Enter" && login();
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ref: passwordRef,
                    label: "Password",
                    type: "password",
                    className: "mb-10 w-[300px]",
                    onKeyDown: function(e) {
                        return e.key == "Enter" && login();
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            loading: formStatus == "loading" || formStatus == "success",
                            onClick: login,
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: "/auth/signup",
                            className: "text-right text-sm",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "text-right text-sm",
                                children: [
                                    "Don",
                                    "'",
                                    "t have an account?",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: "Create one"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                formStatus == "error" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10 text-red-500",
                    children: "Bad credentials, try again."
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [955,98,424,774,888,179], function() { return __webpack_exec__(7265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);